import { applyKnownPatientToHandoverNote } from './handoverUtils';

export function toNotePatientContext(patient) {
  if (!patient) return null;
  return {
    name: patient.nameEn || patient.name || null,
    room: patient.room ?? null,
    age: patient.age ?? null,
    sex: patient.sex ?? null,
    details_source: 'patient_record',
  };
}

const PATIENT_VERIFICATION_FLAG_PATTERNS = [
  'patient identification not documented',
  'patient location not documented',
  'patient name not detected',
  'patient name not documented',
  'patient name not identified',
  'patient name missing',
  'identification not documented',
  'location not documented',
  'room/bed missing',
  'room bed missing',
  'room number not detected',
  'room number not documented',
  'room number not identified',
  'room number missing',
  'room not documented',
  'room not detected',
  'room not identified',
  'room/bed not documented',
  'location not documented',
  'patient name not identified in transcript',
  'room not identified in transcript',
  'patient name not detected in transcript',
  'room number not detected in transcript',
  'patient name not recognized',
  'Please verify patient age',
  'please verify — patient name',
  'please verify — room number',
  'verify identifiers if required',
  'identifiers if required for documentation',
  'patient age, and patient sex not provided',
  'patient age and patient sex not provided',
  'room number, patient age, and patient sex',
  'patient age not provided',
  'patient sex not provided',
  'room number not provided in transcript',
];

function stripPatientVerificationFlags(flags = []) {
  if (!Array.isArray(flags)) return [];

  return flags.filter((flag) => {
    const flagText =
      typeof flag === 'string' ? flag : flag?.message || flag?.text || flag?.value || '';
    if (!flagText) return true;
    const normalized = String(flagText).toLowerCase();
    return !PATIENT_VERIFICATION_FLAG_PATTERNS.some((pattern) =>
      normalized.includes(pattern.toLowerCase())
    );
  });
}

export function applyKnownPatientToNote(note, patientContext) {
  if (!note || !patientContext) return note;

  return {
    ...note,
    patient: {
      ...(note.patient || {}),
      ...patientContext,
      details_source: 'patient_record',
    },
    flags: stripPatientVerificationFlags(note.flags || []),
  };
}

export function isPatientRecordContext(patient) {
  return patient?.details_source === 'patient_record';
}

export function applyPatientToGenerationResult(result, patient) {
  if (!result || !patient) return result;

  const patientContext = toNotePatientContext(patient);
  const generatedNotes = (result.generatedNotes || []).map((entry) => {
    if (!entry.note) return entry;
    return {
      ...entry,
      note:
        entry.type === 'handover'
          ? applyKnownPatientToHandoverNote(entry.note, patientContext)
          : applyKnownPatientToNote(entry.note, patientContext),
    };
  });

  const resolvedOpenaiNote =
    generatedNotes.find((entry) => entry.note)?.note || result.openaiNote || null;

  return {
    ...result,
    generatedNotes,
    openaiNote: resolvedOpenaiNote,
    cortiNote: result.cortiNote ? applyKnownPatientToNote(result.cortiNote, patientContext) : null,
    patientId: patient.id,
  };
}
